import React from "react";
import { LoaderStyles } from "./styles";

const Loader = () => {
  return <LoaderStyles />;
};

export default Loader;
